<script>
import BannerApi from "@/services/banner-api";

export default {

  components: {},

  data() {
    return {
      loginBanner: null
    };
  },

  mounted() {
    this.findLoginBanner();
  },

  methods: {

    findLoginBanner() {

      BannerApi.getLoginBanner()
        .then((result) => {

          if (result) {
            this.loginBanner = result;
          }

        });

    }

  }

};
</script>

<style scoped>
#auth-container {

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: local;
  height: 1080px;
  
  background-color: #c7cacf;
}
</style>

<template>

  <div
    id="auth-container"
    class="pt-0 pt-sm-1 d-xs-none"
    :style="loginBanner && loginBanner.generatedName
      ? {
          backgroundImage:
            'url(/api/image/get/' + loginBanner.generatedName + ')'
        }
      : {
          backgroundImage:
            'url(' + require('@/assets/images/background/back.png') + ')'
        }"
  >

    <div class="account-pages my-0 pt-0 my-sm-5 pt-sm-5">
      <div class="container">
        <slot />
      </div>
    </div>
  </div>
</template>
